<template>
  <div class="loader">
    <div class="loader__line"/>
    <div class="loader__line"/>
    <div class="loader__line"/>
    <div class="loader__line"/>
    <div class="loader__line"/>
  </div>
</template>
<script>

export default {
  name: 'Loader'
}

</script>
